import React, { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { blogsTableColumnsConfig } from "./blogsTableColumnDef";
import { Table } from "../../../component/table/Table";

export const BlogsTablePage = ({ data }) => {
  const navigate = useNavigate();

  const handleNavigateToBlogDetail = useCallback(
    (blogId) => {
      navigate(`/blogs/${blogId}`);
      console.log(blogId);
    },
    [navigate]
  );

  const columnDefs = useMemo(
    () => blogsTableColumnsConfig(handleNavigateToBlogDetail),
    [handleNavigateToBlogDetail]
  );
  return <Table data={data} columns={columnDefs} />;
};
